/**
 * Deploy-specific configuration whitelists
 */
export default [
    'bridgeChannel',
    'customParticipantMenuButtons',
    'customToolbarButtons',
    'defaultLogoUrl',
    'deploymentUrls',
    'disableRecordAudioNotification',
    'liveStreaming',
    'peopleSearchUrl',
    'prejoinConfig',
    'salesforceUrl'
];
